import JobZImage from "../../../../common/jobz-img";
import { loadScript } from "../../../../../globals/constants";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axiosInstance from '../../../../../axiosInstance';
import { API_URL } from "../../../../../config";
import { Helmet } from 'react-helmet-async';
import { publicUser } from "../../../../../globals/route-names";

const colors = [
    "#E63946", // red
    "#457B9D", // blue-gray
    "#2A9D8F", // teal
    "#F4A261", // orange
    "#264653", // deep teal
    "#8E44AD", // purple
    "#D7263D", // crimson
    "#3A86FF", // vivid blue
    "#06D6A0", // mint green
    "#FFBE0B", // yellow
    "#8338EC", // violet
    "#FF006E", // pink
    "#118AB2", // bright blue
    "#073B4C", // dark navy
    "#F77F00", // deep orange
    "#38B000", // green
    "#7209B7", // purple
    "#FF7F50", // coral
    "#008080", // classic teal
];

function getRandomColor(seed) {
    const index = seed.charCodeAt(0) % colors.length;
    return colors[index];
}

function CandidateList() {
    const { t } = useTranslation();
    const [candidates, setCandidates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [imgError, setImgError] = useState(false);

    useEffect(() => {
        loadScript("js/custom.js");

        const fetchUsers = async () => {
            try {
                const response = await axiosInstance.get(`${API_URL}/candidate-All-list`);
                const allUsers = response.data.data;

                setCandidates(allUsers);
                setLoading(false);
            } catch (err) {
                if (err.response?.data?.message) {
                    setError(err.response.data.message);
                } else {
                    setError("Failed to load candidates. Please try again later.");
                }
                setLoading(false);
            }
        };

        fetchUsers();
    }, []);

    return (
        <>
            <Helmet>
                <title>Worker | CV Diffusion</title>
                <meta name="description" content="Welcome to the home page of MyApp." />
            </Helmet>

            {/* CANDIDATES START */}
            <div className="section-full p-t120 p-b90 site-bg-white twm-candidate-h-page7-wrap pos-relative">
                <div className="container">
                    <div className="section-head center wt-small-separator-outer">
                        <h2 className="wt-title">{t("Candidate List")}</h2>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="section-content">
                        <div className="twm-candidate-h-page7">
                            {loading ? (
                                <div className="text-center">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ) : error ? (
                                <div className="text-danger text-center">{error}</div>
                            ) : (
                                <div className="row d-flex justify-content-center m-b30">
                                    {candidates.map((candidate) => (
                                        <div
                                            key={candidate.id}
                                            className="col-xl-3 col-lg-4 col-md-6 col-sm-6"
                                        >
                                            <div className="twm-candidates-grid-h-page7 m-b30">
                                                <div className="twm-top-section-content">
                                                    <div className="twm-media">
                                                        <div className="twm-media-pic">
                                                            <span>
                                                                {/* {candidate?.photo_url && !imgError ? (
                                                                    <img
                                                                        src={candidate.photo_url}
                                                                        alt="Profile"
                                                                        className="w-full h-auto rounded-full"
                                                                        onError={() => setImgError(true)}
                                                                    />
                                                                ) : ( */}
                                                                <div
                                                                    className="w-full h-auto rounded-full"
                                                                    style={{
                                                                        minWidth: "50px",
                                                                        backgroundColor: getRandomColor(candidate?.first_name?.[0]?.toUpperCase() || "A"),
                                                                        fontSize: "45px",
                                                                        fontWeight: "600",
                                                                        color: "#fff",
                                                                    }}
                                                                >
                                                                    {candidate?.first_name
                                                                        ? `${candidate.first_name[0]}`.toUpperCase()
                                                                        : candidate?.first_name?.[0]?.toUpperCase() || "?"}
                                                                </div>
                                                                {/* )} */}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="twm-mid-content">
                                                        <div className="twm-candidates-tag">
                                                            <span>{t("Featured")}</span>
                                                        </div>
                                                        <h4>{`${candidate.first_name}`}</h4>
                                                        <p>{candidate.designation || "Worker"}</p>
                                                    </div>
                                                </div>
                                                <div className="twm-fot-content">
                                                    <div className="twm-left-info">
                                                        <p className="twm-candidate-address">
                                                            <i className="feather-map-pin" />
                                                            {candidate.country || t("Not specified")}
                                                        </p>
                                                        <NavLink to={publicUser.candidate.GRID.replace(":id", candidate.id)}>
                                                            <p className="twm-candidate-address">
                                                                <i className="feather-eye" />
                                                                {t("View")}
                                                            </p>
                                                        </NavLink>
                                                        <div className="twm-jobs-vacancies">
                                                            {candidate.salary || ""}
                                                            <span>{candidate.salary ? "/ Day" : ""}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div >
            {/* CANDIDATES END */}
        </>
    )
}

export default CandidateList;